import {
    HostBinding,
    Input
} from "@angular/core";
import { Appearance } from "./appearance";
import { OverlayPosition } from "../classes/overlay-position";

/**
 * Base class for all container components which hold common properties
 * This includes layout settings such as wrapping and inline
 */
export abstract class Overlay extends Appearance {
    // io
    @Input() position: string;
    @Input() coordinates: OverlayPosition;
    @Input() target: string | Node;
}



// WEBPACK FOOTER //
// ./client-src/app/core/baseObjects/overlay.ts